export const getResponseTimeValueTextId = (responseTime) => {
  switch (true) {
    case responseTime < 3600:
      return 'responseTimeLessThanOneHour'
    case responseTime < 21600:
      return 'responseTimeFewHours'
    case responseTime < 86400:
      return 'responseTimeOneDay'
    case responseTime < 172800:
      return 'responseTimeSomeDays'
    default:
      return null;
  }
};

export const getAcceptanceRateValueTextId = (acceptanceRate) => {
  switch (true) {
    case acceptanceRate < 0:
      return null;
    case acceptanceRate < 25:
      return 'acceptanceRateBad';
    case acceptanceRate < 50:
      return 'acceptanceRateAverage';
    case acceptanceRate < 75:
      return 'acceptanceRateGood';
    case acceptanceRate < 100:
      return 'acceptanceRateVeryGood';
    default:
      return null;
  }
};
